/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
console.log("Hello World! (from create-block-protein-calculator block)");
/* eslint-enable no-console */

/**
 * Protein calculator based on Eden/Atiyah design logic.
 * @param {number} weightLb - User's current weight in pounds.
 * @param {string} fitnessGoal - 'lose weight', 'maintain weight', or 'build muscle'.
 */
function calculateProteinTarget(weightLb, fitnessGoal) {
	const goal = fitnessGoal;

	// 1. Define the specific multipliers from the feedback
	const multipliers = {
		'maintain weight': 0.36,
		'lose weight': 0.54,
		'build muscle': 1.0
	};

	// Default to maintenance if the input doesn't match
	const multiplier = multipliers[goal] || multipliers['maintain weight'];

	// 2. Calculate the specific target for the selected goal
	const target = Math.round(weightLb * multiplier);

	// 3. Return the recommended target and the full breakdown for UI display
	return {
		recommendedTarget: target,
		breakdown: {
			loseWeight: Math.round(weightLb * 0.54),
			maintain: Math.round(weightLb * 0.36),
			buildMuscle: Math.round(weightLb * 1.0)
		}
	};
}

const updateProteinCard = ( proteinTarget, fG ) => {
	console.log( proteinTarget );
	console.log( proteinTarget.recommendedTarget );

	document.getElementById("displayProtein").textContent = proteinTarget.recommendedTarget;
	document.querySelectorAll('.answer').forEach(el => el.classList.remove('active') );
	document.querySelector('.answer.' + fG.replace(" ", "-") ).classList.add('active');
	document.querySelector('.answer.lose-weight .answer-value').textContent = proteinTarget.breakdown.loseWeight;
	document.querySelector('.answer.maintain-weight .answer-value').textContent = proteinTarget.breakdown.maintain;
	document.querySelector('.answer.build-muscle .answer-value').textContent = proteinTarget.breakdown.buildMuscle;
};

// --- Main Logic ---
document.addEventListener("DOMContentLoaded", () => {

	const form = document.getElementById("proteinForm");

	const currentWeightInput = document.getElementById("currentWeight");
	const fitnessGoalInput = document.getElementById("fitnessGoal");

	form.addEventListener("submit", (event) => {
		event.preventDefault();

     	const cW = parseFloat(currentWeightInput.value), fG = fitnessGoalInput.value;

		const proteinTarget = calculateProteinTarget( cW, fG );

		if ( !cW || !fG ) {
			showToast("Please fill in all fields to unlock your personalized plan.");
			return;
		}

		try {
			updateProteinCard( proteinTarget, fG );

		} catch (e) {
			console.error(e);
			showToast("Error processing plan. Please check inputs.");
		}
	});
});